import {ISearchService} from './types';

/**
 * Import the appropriate search provider server here based on store configuration
 */

// import Service from './services/Klevu';
import Service from './services/BoostCommerce';


const SearchService: ISearchService = {
  methods: {
    handleSearch: Service.methods.handleSearch,
    getFilters: Service.methods.getFilters,
    getProductResults: Service.methods.getProductResults,
    getCmsContent: Service.methods.getCmsContent,
  },
}

export default SearchService